// react
import React, { useState, useContext} from 'react';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';


// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FranquiaForm from "./FranquiaForm";

// services
import { useGetApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function FranquiaList({history, callUpdateScrollTOP}) {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});          

    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi("franquias");

    const handleView = (resetItem, item) => {    
        if(resetItem)
            setItem(null);
        
        let show = showFormView === true ? false : true;
        setshowFormView(show);  
        callUpdateScrollTOP();
        
        if(!item)
            return;

        var vefifyExists = list.filter(obj => {
            return obj.franquiaId === item.franquiaId;
        });

        if(vefifyExists.length > 0)
        {           
            const updateList = list.map(l => (l.franquiaId === item.franquiaId ? item : l));
            setListAtualiza(updateList);                     
        }
        else
        {      
            const addItemList = [...list, item];
            setListAtualiza(addItemList); 
        }
    };

    const handleEdit = row => {       
        setItem(row);
        handleView(false);
    };     

    const columnsProp = [
    {
        Header: t('label.cnpj'),
        accessor: "cnpjcpf",
    },
    {
        Header: t('label.fantasy'),
        accessor: "descricao",
    },
    {
        Header: t('label.responsible'),
        accessor: "nomeResponsavel",
    },
    {
        Header: t('accreditation.social_reason'),
        accessor: "razaoSocial",
    },
    {
        Header: t('label.status'),
        Cell: row => ( <span> { row.original.ativo ? t('label.active') : t('label.inactive')} </span>),
        filterable: false
    }]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">   
                                   
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>      
                          
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
    <div>
        
        {!showFormView &&
        <GridContainer>            
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>Lista de Franqueadores </h4>
                    </CardHeader>
                    <CardBody>
                        {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                        <ReactTable
                            loading = {isLoadingList}
                            data={list}
                            filterable
                            defaultFilterMethod = {noCaseSensitive}
                            columns={columns}
                            defaultPageSize={10}
                            minRows={5}
                            showPaginationBottom={true}
                            className="-striped -highlight"
                            previousText={t('button.previous')}
                            nextText={t('button.next')}
                            loadingText={t('label.loading')+"..."}
                            noDataText={t('information_message.no_records_found')+"!"}
                            pageText={t('label.page')}
                            ofText={t('label.of')}
                            rowsText={t('label.rows')}
                        />
                    </CardBody>
                </Card>
            </GridItem>            
        </GridContainer>
        }     

        
        {showFormView && 
            <FranquiaForm item={item} handleView={handleView} history={history} />}    
    </div>
    );
}
